import React, { useEffect, useState } from "react";
import pic1 from "../../assets/OfferingB/Our_Offering_Tag.svg";
import pic2 from "../../assets/OfferingB/Background_Co_engineer.svg";
import pic3 from "../../assets/OfferingB/hero_bg.svg";
import TagButton from "../common/TagButton";

const HeroSectionOff = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  return (
    <section
      id="ai_engineering"
      className="w-full h-[360px] md:h-[400px] flex items-center justify-center bg-no-repeat bg-center bg-[length:100%_auto]"
      style={{ backgroundImage: isMobile ? "none" : `url(${pic3})` }}
    >
      <div className="flex relative flex-col w-full px-5 max-w-[1440px]">
        {/* Tag aligned left */}
        {/* <div className="mb-4 absolute md:block md:left-[225px] md:right-[20px] top-[-16px] md:px-[120px] "> */}
        <div className="mb-4 absolute left-14 md:left-[225px] md:right-[20px] md:top-[-18px] md:px-[120px] ">

          {/* <img src={pic1} alt="Tag" /> */}
        <TagButton text="Co-Build Production-Grade AI"></TagButton>
        </div>

        {/* Main heading split into two lines */}
        <div className="w-full text-center mt-[36px]">
          <div className="w-full flex flex-col items-center">
            <h1
              className="md:text-[50px] text-[32px] font-bold bg-clip-text text-transparent font-montserrat w-fit"
              style={{
                backgroundImage:
                  "linear-gradient(90deg, #000 0%, #0060C7 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              Build AI Into Your
            </h1>
            <h1
              className="md:text-[50px] text-[32px] font-bold bg-clip-text text-transparent font-montserrat"
              style={{
                backgroundImage:
                  "linear-gradient(90deg, #000 0%, #0060C7 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              Product, Stack and Workflow
            </h1>
          </div>
        </div>

        {/* Bottom description */}
        <div className="w-full flex justify-end mt-6 pr-0 md:pr-32 ">
          <div className="w-[440px] flex flex-col gap-2 sm:items-start items-center text-center sm:text-left">
            <img src={pic2} alt="Badge"   className="sm:mx-0 mx-auto "/> 
            <p className="font-light font-roboto text-[16px] w-full text-center">
              We co-engineer AI features with your team from infra to front end
              to ship production-grade capabilities, faster.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSectionOff;
